import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../json_query';
import { offerHelper } from '../../../offer/presenters';
import { IBreadcrumb, IOffer } from '../../../offer/types';
import { TUser } from '../../../types/user';

interface IParameters {
  jsonQuery: IJsonQuery;
  recommendations: IOffer[];
  allRecommendations: IOffer[];
  modelVersion: string | null;
  pageNumber: number;
  breadcrumbs: IBreadcrumb[];
  queryString: string;
  offersQty: number;
  user: TUser;
  mlRankingGuid: string | null;
  mlRankingModelVersion: string | null;
  mlSearchSessionGuid: string | null;
}

export const trackMLSuggestionsShown = ({
  jsonQuery,
  recommendations,
  allRecommendations,
  modelVersion,
  pageNumber,
  breadcrumbs,
  queryString,
  offersQty,
  user,
  mlRankingGuid,
  mlRankingModelVersion,
  mlSearchSessionGuid,
}: IParameters) => {
  const previousRecommendationsCount = Math.max(allRecommendations.length - recommendations.length, 0);

  const products = recommendations.map((offer, index) => {
    const { id, variant, ownerId } = offerHelper(offer).getAnalyticsInfo();

    return {
      id,
      offerType: 'offer',
      position: previousRecommendationsCount + index + 1,
      modelVersion: modelVersion || 0,
      published: offer.status === 'published',
      variant: variant ? variant.split('/') : [],
      ownerId,
    };
  });

  const ebcObject = {
    name: 'oldevent',
    category: 'page',
    action: 'newpage_infinite_search',
    label: '',
    searchConditions: jsonQuery,
    modelVersion:
      typeof modelVersion !== 'object' && typeof modelVersion !== 'undefined' ? String(modelVersion) : undefined,
    products,
    page: {
      listingType: 'extended',
      sortType: jsonQuery.sort ? jsonQuery.sort : 'default',
      pageNumber,
      breadCrumbs: breadcrumbs.map(breadcrumb => breadcrumb.title),
      queryString,
      extra: {
        mlSearchSessionGuid,
      },
      offersQty,
      mlRankingGuid,
      mlRankingModelVersion,
      pageType: 'Listing',
      siteType: 'desktop',
    },
    user: {
      userId: user.isAuthenticated && user.userId ? Number(user.userId) : undefined,
      isAuthorized: user.isAuthenticated,
    },
  };

  ca('eventEbc', ebcObject);
};
